<template>
  <div>
    <div class="inspection-preview-toolbar">
      <button type="button" class="btn btn-sm btn-primary" @click="toggleServicePreview">
        {{ previewButtonLabel }}
      </button>
      <span v-if="previewError" class="ml-2 text-danger">{{ previewError }}</span>
      <span v-if="previewLoading" class="ml-2 text-muted">Chargement des correspondances...</span>
      
    </div>
    <table class="table table-bordered w-100">
      <thead>
        <tr>
          <th style="width: 250px">Description</th>
          <th class="bg-green-jungle">&nbsp;</th>
          <th class="bg-yellow-lemon">&nbsp;</th>
          <th class="bg-red">&nbsp;</th>
          <th>Commentaire*</th>
          <th :style="{ width: columnWidth, maxWidth: columnWidth }">
            <template v-if="previewVisible">Service proposé</template>
            <label v-else class="mb-0" style="cursor: pointer;" title="Tout cocher / tout décocher">
              <input type="checkbox" class="auto-service-master" :checked="allAutoServiceChecked" :indeterminate.prop="someAutoServiceChecked && !allAutoServiceChecked" @change="toggleAutoServiceAll($event.target.checked)">
              Auto-service
            </label>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(verification, index) in inspectionData.verifications" :key="index">
          <td style="padding: 8px">
            <input type="hidden" :name="`invoice_inspection_verification_id[${invoiceInspectionId}][${index}]`" :value="verification.invoice_inspection_verification_id">
            <input type="hidden" v-if="verification.invoice_inspection_verification_checked_box == null" :name="`invoice_inspection_verification_checked_box[${invoiceInspectionId}][${index}]`" value="0">
            <input type="hidden" :name="`invoice_inspection_verification_label[${invoiceInspectionId}][${index}]`" :value="verification.invoice_inspection_verification_label || ''">
            {{verification.invoice_inspection_verification_label}}
          </td>
          <td style="width: 50px; vertical-align: middle; text-align: center;"  class="bg-green-jungle" :class="{'checked': verification.invoice_inspection_verification_checked_box == '1'}" 
            @click="verification.invoice_inspection_verification_checked_box = verification.invoice_inspection_verification_checked_box == 1 ? 0 : 1;">
            <input type="checkbox" :name="`invoice_inspection_verification_checked_box[${invoiceInspectionId}][${index}]`" 
            :checked="verification.invoice_inspection_verification_checked_box == '1'" value="1">
          </td>
          <td style="width: 50px; vertical-align: middle; text-align: center;" class="bg-yellow-lemon" :class="{'checked': verification.invoice_inspection_verification_checked_box == '2'}" 
          @click="verification.invoice_inspection_verification_checked_box = verification.invoice_inspection_verification_checked_box == 2 ? 0 : 2;">
            <input type="checkbox" :name="`invoice_inspection_verification_checked_box[${invoiceInspectionId}][${index}]`" 
            :checked="verification.invoice_inspection_verification_checked_box == '2'" value="2">
          </td>
          <td style="width: 50px; vertical-align: middle; text-align: center;" class="bg-red" :class="{'checked': verification.invoice_inspection_verification_checked_box == '3'}" 
          @click="verification.invoice_inspection_verification_checked_box = verification.invoice_inspection_verification_checked_box == 3 ? 0 : 3;">
            <input type="checkbox" :name="`invoice_inspection_verification_checked_box[${invoiceInspectionId}][${index}]`" 
            :checked="verification.invoice_inspection_verification_checked_box == '3'" value="3">
          </td>
          <td>
            <textarea  v-html="verification.invoice_inspection_verification_comment" ref="comment-box" @input="handleCommentInput(verification); editInspection()" :required="parseInt(verification.invoice_inspection_verification_checked_box) > 1" class="comment-box" :name="`invoice_inspection_verification_comment[${invoiceInspectionId}][${index}]`"></textarea>
          </td>
          <td :style="{ padding: '8px', width: columnWidth, maxWidth: columnWidth, verticalAlign: 'middle' }">
            <div v-if="previewVisible">
              <select
                class="form-control inspection-service-select"
                :data-verification-index="index"
                :name="`invoice_inspection_verification_service_id[${invoiceInspectionId}][${index}]`"
              >
                <option value="">-- Aucun --</option>
                <option v-for="service in serviceOptions" :key="service.id" :value="service.id">
                  {{ service.text }}
                </option>
              </select>
            </div>
            <div v-else class="text-center">
              <input type="hidden" :name="`invoice_inspection_verification_auto_service[${invoiceInspectionId}][${index}]`" value="0">
              <input type="checkbox" class="auto-service-checkbox" :name="`invoice_inspection_verification_auto_service[${invoiceInspectionId}][${index}]`" value="1" v-model="verification.auto_service">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

  export default {
    name: "inspection-form",
    props: {
      inspection: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        inspectionData: this.inspection,
        serviceOptions: [],
        previewVisible: false,
        previewLoading: false,
        previewError: '',
        previewInitialized: false,
        lastPreviewSignature: '',
      }
    },
    computed: {
      columnWidth() {
        return this.previewVisible ? '160px' : '118px';
      },
      allAutoServiceChecked() {
        return this.inspectionData.verifications.length > 0
          && this.inspectionData.verifications.every(v => v.auto_service);
      },
      someAutoServiceChecked() {
        return this.inspectionData.verifications.some(v => v.auto_service);
      },
      invoiceInspectionId() {
        return this.inspectionData.invoice_inspection_id
      },
      previewButtonLabel() {
        return this.previewVisible ? 'Mode auto' : 'Prévisualiser les services';
      }
    },
    mounted () {
      
      for (const verification of this.inspectionData.verifications) {
        if (verification.invoice_inspection_verification_comment != null) {
          verification.invoice_inspection_verification_comment = this.decodeApostrophes(verification.invoice_inspection_verification_comment);
        }
        if (verification.invoice_inspection_verification_label != null) {
          verification.invoice_inspection_verification_label = this.decodeApostrophes(verification.invoice_inspection_verification_label);
        }
        if (verification.invoice_inspection_verification_service_id == null) {
          verification.invoice_inspection_verification_service_id = '';
        }
        this.$set(verification, 'auto_service', true);
      }

      setTimeout(() => {
        this.autoResize();
      }, 500);

    },
    methods: {
      toggleAutoServiceAll(value) {
        for (const verification of this.inspectionData.verifications) {
          this.$set(verification, 'auto_service', !!value);
        }
      },
      getSectionFormSignature() {
        const fields = $(this.$el).find('input[name], textarea[name], select[name]');
        return fields.serialize();
      },
      decodeApostrophes(value) {
        if (value == null) {
          return value;
        }

        return String(value)
          .replace(/\&\#039;/g, "'")
          .replace(/&#039;/g, "'")
          .replace(/&apos;/g, "'")
          .replace(/&amp;apos;/g, "'");
      },
      handleCommentInput(verification) {
        this.autoResize();
        //verification.invoice_inspection_verification_checked_box = "3";
      },
      toggleServicePreview() {
        if (this.previewVisible) {
          this.previewVisible = false;
          return;
        }

        // Always reload so the proposed services reflect the current Auto-service checkboxes.
        this.loadServicePreview();
      },
      loadServicePreview() {
        if (this.previewLoading) {
          return;
        }

        this.previewLoading = true;
        this.previewError = '';

        $.post(`${window.baseUrl}invoice/editinspection/preview-services`, { form: this.getSectionFormSignature() }, (response) => {
          this.previewLoading = false;

          if (!response || response.ok !== 1) {
            this.previewError = (response && response.msg) ? response.msg : 'Impossible de prévisualiser les services.';
            return;
          }

          this.serviceOptions = response.services || [];
          this.applyPreviewMatches(response.matches || {});
          this.previewInitialized = true;
          this.previewVisible = true;
          this.$nextTick(() => {
            this.initServiceSelect2();
          });
        }, 'json').fail(() => {
          this.previewLoading = false;
          this.previewError = 'Erreur lors du chargement de la prévisualisation.';
        });
      },
      applyPreviewMatches(matches) {
        const inspectionMatches = matches[this.invoiceInspectionId] || {};

        for (let index = 0; index < this.inspectionData.verifications.length; index++) {
          const verification = this.inspectionData.verifications[index];
          const rowMatch = inspectionMatches[index] || null;
          const nextValue = rowMatch && rowMatch.service_id ? String(rowMatch.service_id) : '';

          this.$set(verification, 'invoice_inspection_verification_service_id', nextValue);
        }
      },
      getSelect2DropdownParent() {
        // When Select2 is rendered inside a modal, keep the dropdown inside that modal container
        // so it stacks above the overlay without z-index hacks.
        const modalParent = $(this.$el).closest('.bootbox.modal, .modal');
        return modalParent.length ? modalParent : $(document.body);
      },
      initServiceSelect2() {
        const that = this;
        const dropdownParent = this.getSelect2DropdownParent();

        $(this.$el).find('.inspection-service-select').each(function () {
          const $select = $(this);
          const verificationIndex = parseInt($select.data('verification-index'), 10);
          const verification = that.inspectionData.verifications[verificationIndex];

          if ($select.data('select2')) {
            $select.select2('destroy');
          }

          $select.select2({
            language: 'fr',
            allowClear: true,
            placeholder: '-- Aucun --',
            dropdownParent: dropdownParent,
            dropdownPosition: 'below', // marche po
            width: '144px',
            minimumResultsForSearch: 0,
            templateResult: function (state) {
              if (!state.id) {
                return state.text || 'Chargement...';
              }

              return $('<span>' + state.text + '</span>');
            },
            templateSelection: function (state) {
              return state.text || '-- Aucun --';
            }
          }).off('change.inspectionService')
          .on('change.inspectionService', function () {
            that.$set(verification, 'invoice_inspection_verification_service_id', $(this).val() || '');
          })          
          .on('select2:open', function () {
            var $dropdown = $('.select2-container--open .select2-dropdown');

            setTimeout(function () {
              console.log('Adjusting Select2 dropdown position for inspection service select');
                $dropdown
                    .removeClass('select2-dropdown--above')
                    .addClass('select2-dropdown--below')
                    .css({
                        top: '100%',
                        bottom: 'auto'
                    });
            }, 0);
          });

          var select2Instance = $select.data('select2');
          if (select2Instance && select2Instance.$container) {
            select2Instance.$container.addClass('inspection-service-select2');
          }

          $select.off('select2:open.inspectionService').on('select2:open.inspectionService', function () {
            var dropdown = $('.select2-container--open .select2-dropdown').last();
            if (dropdown && dropdown.length) {
              dropdown.addClass('inspection-service-dropdown');
              dropdown.css({ width: '160px', 'max-width': '160px' });
            }
          });

          const currentValue = verification.invoice_inspection_verification_service_id || '';
          if (currentValue) {
            $select.val(String(currentValue)).trigger('change.select2');
          }
        });
      },
      editInspection () {
       
        var form = $("#form_inspection")
        var data = this.inspectionData.verifications
        //console.log(event)
        
       $.post(`${window.baseUrl}invoice/editinspection/save`, { form: form.serialize() }, function (results) {
          console.log(results)
          //console.log(data)
        }, "json", function (textStatus) {
          console.log("Request editInspection failed: " + textStatus);
        });
      },

      autoResize() {
        for (const textarea of this.$refs["comment-box"]) {
          textarea.style.height = "auto";
          textarea.style.height = (textarea.scrollHeight) + "px";
        }
      }
    },
  }

</script>

<style lang="scss" scoped>
.table td {
  padding: 0;

  &:not(.checked){
    background-image: linear-gradient(to right, rgba(255,255,255,0.6), rgba(255,255,255,0.6)) !important;
  }

  input[type=checkbox] {
    width: 15px;
    height: 15px;
    pointer-events: none;
  }

  input[type=checkbox].auto-service-checkbox,
  input[type=checkbox].auto-service-master {
    pointer-events: auto;
  }
}

.comment-box {
  display: block; 
  width: 100%; 
  min-width: 200px; 
  border: none; 
  resize: vertical;
  min-height: 42px;
}

.inspection-preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 8px;
}

.inspection-service-select2,
.inspection-service-select2.select2-container,
.inspection-service-select2 .select2-selection--single {
  width: 144px !important;
  max-width: 144px !important;
}

.inspection-service-select2 .select2-selection--single,
.inspection-service-select2 .select2-selection__rendered,
.inspection-service-dropdown .select2-results__option {
  font-size: 11px;
}

.inspection-service-select2 .select2-selection__rendered,
.inspection-service-dropdown .select2-results__option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.inspection-service-dropdown,
.inspection-service-dropdown.select2-dropdown {
  width: 160px !important;
  max-width: 160px !important;
}

.inspection-service-dropdown .select2-search--dropdown .select2-search__field {
  width: 100% !important;
  font-size: 11px;
}

.inspection-service-dropdown .select2-results__option {
  padding-right: 6px;
}

</style>

<style lang="scss">
.help-block.help-block-error {
  color: red;
  font-weight: bold;
}
</style>